import { render, staticRenderFns } from "./Gallery10.vue?vue&type=template&id=6b0270ea&scoped=true&"
import script from "./Gallery10.vue?vue&type=script&lang=js&"
export * from "./Gallery10.vue?vue&type=script&lang=js&"
import style0 from "./Gallery10.vue?vue&type=style&index=0&id=6b0270ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0270ea",
  null
  
)

export default component.exports